import React from "react";
import { FaPrint } from "react-icons/fa";

const isObject = (val) => typeof val === "object" && val !== null;

const formatValue = (value, key) => {
  if (key.toLowerCase().includes("password")) {
    return "•".repeat(String(value || "").length || 6);
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(", ") : "-";
  }

  if (isObject(value)) {
    return "-"; // return "Tidak tersedia";
  }

  return value !== undefined && value !== null && value !== "" ? value : "-";
};

const formatLabel = (key) => {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const ModalDetail = ({ data, onClose, extraButtons = [] }) => {
  if (!data) return null;

  const entries = Object.entries(data);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 bg-black bg-opacity-50">
      <div className="w-full max-w-xl rounded-lg bg-white shadow-md overflow-hidden max-h-[85vh]">
        <div className="px-5 py-4 overflow-y-auto max-h-[85vh] text-sm">
          <h2 className="mb-4 text-lg font-semibold text-center text-gray-800">
            Detail Data
          </h2>

          <div className="space-y-2">
            {entries.map(([key, value]) => (
              <div key={key} className="flex">
                <div className="w-1/3 font-medium text-gray-600 capitalize">
                  {formatLabel(key)}
                </div>
                <div className="w-2/3 text-gray-800 break-words whitespace-pre-wrap">
                  {formatValue(value, key)}
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center justify-between gap-2 mt-5">
            <div className="flex flex-wrap gap-2">
              {extraButtons.map((btn, idx) => (
                <button
                  key={idx}
                  onClick={btn.onClick}
                  className="inline-flex items-center gap-1 px-3 py-1 text-xs text-white transition bg-green-600 rounded hover:bg-green-700"
                >
                  <FaPrint className="text-xs" />
                  <span>{btn.label}</span>
                </button>
              ))}
            </div>

            <button
              onClick={onClose}
              className="px-4 py-1 text-xs text-white transition bg-gray-600 rounded hover:bg-gray-700"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDetail;
